// extracted by mini-css-extract-plugin
export default {"button":"oKur1IwpQa","title":"wGRVv8ePCh","icon":"qunGTY67pB","content":"_31MbZuhQKV","expanded":"MaNhqadKoP"};